export default Vue => {
    Vue.component("m-pull-up", () =>
        import( /* webpackChunkName: "component-home" */ './m-pull-up.vue'));
};